import axios from "../helper/AxiosHelper";
import ApiHelper from "./ApiHelper";



const appendYear = (params, year) => {
  if (year !== undefined && year !== null && year !== "") {
    params.append("year", year);
  }
};

const getTopSkillParticipantCount = async (orgType, year) => {
  const params = new URLSearchParams({ org_type: orgType });
  appendYear(params, year);

  const response = await axios.get(`/passport/getTopSkillParticipantCount?${params.toString()}`);

  return ApiHelper.processResponse(response);
};

// getTopMemberPlayTimeWithOrgSkill?org_id=145&skill_code=hoshun_karate
const getTopMemberPlayTimeWithOrgSkill = async (orgID, skillCode, year) => {
  const params = new URLSearchParams({ org_id: orgID, skill_code: skillCode });
  appendYear(params, year);

  const response = await axios.get(`/passport/getTopMemberPlayTimeWithOrgSkill?${params.toString()}`);

  return ApiHelper.processResponse(response);
}



// getTopMemberPlayTimeWithOrgSkill?org_id=145&skill_code=hoshun_karate
const getTopMemberPlayTime = async (orgType, year) => {
  const orgID = 0;
  const skillCode = '';

  const params = new URLSearchParams({
    org_id: orgID,
    skill_code: skillCode,
    org_type: orgType,
  });
  appendYear(params, year);

  const response = await axios.get(`/passport/getTopMemberPlayTimeWithOrgSkill?${params.toString()}`);

  return ApiHelper.processResponse(response);
}



const getTopOrgPlayTime = async (orgType, year) => {
  const params = new URLSearchParams({ org_type: orgType });
  appendYear(params, year);

  const response = await axios.get(`/passport/getTopOrgPlayTime?${params.toString()}`);

  return ApiHelper.processResponse(response);
}


const getTopSkillPlayer = async (skillCode, orgType, year) => {
  const params = new URLSearchParams({ skill_code: skillCode });
  if (orgType) params.append("org_type", orgType);
  appendYear(params, year);

  const response = await axios.get(`/passport/getTopSkillPlayer?${params.toString()}`);

  return ApiHelper.processResponse(response);
}




export const LeaderboardApi = {
  getTopMemberPlayTime,
  getTopMemberPlayTimeWithOrgSkill,
  getTopOrgPlayTime,
  getTopSkillParticipantCount,
  getTopSkillPlayer,
};
